/**
 * Simple event emitter for showing notifications globally
 */
class NotificationEmitter {
  constructor() {
    this.listeners = [];
  }

  subscribe(listener) {
    this.listeners.push(listener);
    // Return unsubscribe function
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  emit(notification) {
    this.listeners.forEach(listener => listener(notification));
  }

  showError(title, message) {
    this.emit({
      type: 'error',
      title,
      message,
    });
  }

  showWarning(title, message) {
    this.emit({
      type: 'warning',
      title,
      message,
    });
  }

  showSuccess(title, message) {
    this.emit({
      type: 'success',
      title,
      message,
    });
  }

  showInfo(title, message) {
    this.emit({
      type: 'info',
      title,
      message,
    });
  }
}

// Export singleton instance
export const notificationEmitter = new NotificationEmitter();
